"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineHeightSmall = exports.lineHeight = exports.fontWeightThin = exports.fontWeightSemiBold = exports.fontWeightMedium = exports.fontWeightLight = exports.fontWeightExtraLight = exports.fontWeightBold = exports.fontWeight = exports.fontSizeSmall = exports.fontSize = exports.fontFamily = void 0;
const fontFamily = exports.fontFamily = '"Roboto", sans-serif';
const fontSizeSmall = exports.fontSizeSmall = '12px';
const fontSize = exports.fontSize = '14px';
const fontWeightThin = exports.fontWeightThin = 100;
const fontWeightExtraLight = exports.fontWeightExtraLight = 200;
const fontWeightLight = exports.fontWeightLight = 300;
const fontWeight = exports.fontWeight = 400;
const fontWeightMedium = exports.fontWeightMedium = 500;
const fontWeightSemiBold = exports.fontWeightSemiBold = 600;
const fontWeightBold = exports.fontWeightBold = 700;
const lineHeight = exports.lineHeight = '16px';
const lineHeightSmall = exports.lineHeightSmall = '14px';